var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChemicalInjectionPumpDigiUltra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M287.545 291.543H110.167V387.445H287.545V291.543Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M221.459 202.772H176.942V211.721H221.459V202.772Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M233.943 207.246H163.708V216.195H233.943V207.246Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M198.9 386.443C247.906 386.443 287.634 346.715 287.634 297.709C287.634 248.702 247.906 208.975 198.9 208.975C149.894 208.975 110.166 248.702 110.166 297.709C110.166 346.715 149.894 386.443 198.9 386.443Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M198.9 384.638C246.91 384.638 285.829 345.719 285.829 297.709C285.829 249.699 246.91 210.78 198.9 210.78C150.891 210.78 111.971 249.699 111.971 297.709C111.971 345.719 150.891 384.638 198.9 384.638Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M217.655 387.445H180.146V210.862C180.146 210.862 187.275 208.449 199.006 208.449C209.534 208.449 217.655 210.862 217.655 210.862V387.445Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M207.924 387.445H191.08V209.354C191.08 209.354 194.282 208.75 199.549 208.75C204.277 208.75 207.924 209.354 207.924 209.354V387.445Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M203.813 213.988H190.979V215.994H203.813V213.988Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M199.702 230.632H190.979V232.638H199.702V230.632Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M203.813 246.473H190.979V248.479H203.813V246.473Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M203.813 278.359H190.979V280.365H203.813V278.359Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M203.813 311.646H190.979V313.652H203.813V311.646Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M203.813 344.533H190.979V346.539H203.813V344.533Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M203.813 379.424H190.979V381.43H203.813V379.424Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M199.702 262.315H190.979V264.321H199.702V262.315Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M199.702 294.8H190.979V296.806H199.702V294.8Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M199.702 326.784H190.979V328.79H199.702V326.784Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M199.702 361.376H190.979V363.382H199.702V361.376Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M221.986 191.216H175.664V202.771H221.986V191.216Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M176.266 190.853C176.266 190.853 184.162 185.439 199.001 185.439C213.438 185.439 222.062 190.252 222.062 190.252V191.217H176.266V190.853Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M142.652 387.445H125.006V453.62H142.652V387.445Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M104 373.208H139.795L163.256 388.046H104V373.208Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M272.996 387.445H254.948V453.62H272.996V387.445Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M254.947 412.936H142.652V420.532H254.947V412.936Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M293.8 373.208H258.006L234.544 388.046H293.8V373.208Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M221.961 191.88H175.639V202.107H221.961V191.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M181.854 190.978H179.848V203.01H181.854V190.978Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M198.251 190.978H196.245V203.01H198.251V190.978Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M214.946 190.978H212.94V203.01H214.946V190.978Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M730.033 238.999H721.033V438.481H730.033V238.999Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M785.317 238.596H665V76.168L785.317 76.273V238.596Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M782.309 235.588H668.008V79.176L782.309 79.277V235.588Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M668.783 72.158L671.841 69H693.498L696.556 72.158V91.258L693.498 94.266H671.841L668.783 91.258V72.158Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M668.783 77.244L696.556 77.144",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M668.783 85.8671L696.556 85.7671",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M753.909 72.158L756.968 69H778.625L781.683 72.158V91.258L778.625 94.266H756.968L753.909 91.258V72.158Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M753.909 77.244L781.683 77.144",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M753.909 85.8671L781.683 85.7671",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M725.534 72.158L728.592 69H750.249L753.308 72.158V91.258L750.249 94.266H728.592L725.534 91.258V72.158Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M725.534 77.244L753.308 77.144",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M725.534 85.8671L753.308 85.7671",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M697.158 72.158L700.216 69H721.874L724.932 72.158V91.258L721.874 94.266H700.216L697.158 91.258V72.158Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M697.158 77.244L724.932 77.144",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M697.158 85.8671L724.932 85.7671",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M668.783 98.0259L671.841 94.8679H693.498L696.556 98.0259V117.126L693.498 120.134H671.841L668.783 117.126V98.0259Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M668.783 103.112L696.556 103.012",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M668.783 111.735L696.556 111.635",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M753.909 98.0259L756.968 94.8679H778.625L781.683 98.0259V117.126L778.625 120.134H756.968L753.909 117.126V98.0259Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M753.909 103.112L781.683 103.012",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M753.909 111.735L781.683 111.635",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M725.534 98.0259L728.592 94.8679H750.249L753.308 98.0259V117.126L750.249 120.134H728.592L725.534 117.126V98.0259Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M725.534 103.112L753.308 103.012",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M725.534 111.735L753.308 111.635",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M697.158 98.0259L700.216 94.8679H721.874L724.932 98.0259V117.126L721.874 120.134H700.216L697.158 117.126V98.0259Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M697.158 103.112L724.932 103.012",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M697.158 111.735L724.932 111.635",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M668.783 149.841L671.841 146.683H693.498L696.556 149.841V168.942L693.498 171.95H671.841L668.783 168.942V149.841Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M668.783 154.926L696.556 154.827",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M668.783 163.55L696.556 163.45",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M753.909 149.841L756.968 146.683H778.625L781.683 149.841V168.942L778.625 171.95H756.968L753.909 168.942V149.841Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M753.909 154.926L781.683 154.827",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M753.909 163.55L781.683 163.45",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M725.534 149.841L728.592 146.683H750.249L753.308 149.841V168.942L750.249 171.95H728.592L725.534 168.942V149.841Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M725.534 154.926L753.308 154.827",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M725.534 163.55L753.308 163.45",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M697.158 149.841L700.216 146.683H721.874L724.932 149.841V168.942L721.874 171.95H700.216L697.158 168.942V149.841Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M697.158 154.926L724.932 154.827",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M697.158 163.55L724.932 163.45",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M668.783 186.608L671.841 183.45H693.498L696.556 186.608V205.709L693.498 208.717H671.841L668.783 205.709V186.608Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M668.783 191.694L696.556 191.594",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M668.783 200.317L696.556 200.217",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M753.909 186.608L756.968 183.45H778.625L781.683 186.608V205.709L778.625 208.717H756.968L753.909 205.709V186.608Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M753.909 191.694L781.683 191.594",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M753.909 200.317L781.683 200.217",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M725.534 186.608L728.592 183.45H750.249L753.308 186.608V205.709L750.249 208.717H728.592L725.534 205.709V186.608Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M725.534 191.694L753.308 191.594",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M725.534 200.317L753.308 200.217",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M697.158 186.608L700.216 183.45H721.874L724.932 186.608V205.709L721.874 208.717H700.216L697.158 205.709V186.608Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M697.158 191.694L724.932 191.594",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M697.158 200.317L724.932 200.217",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M668.783 123.894L671.841 120.736H693.498L696.556 123.894V142.995L693.498 146.003H671.841L668.783 142.995V123.894Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M668.783 128.98L696.556 128.88",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M668.783 137.603L696.556 137.503",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M753.909 123.894L756.968 120.736H778.625L781.683 123.894V142.995L778.625 146.003H756.968L753.909 142.995V123.894Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M753.909 128.98L781.683 128.88",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M753.909 137.603L781.683 137.503",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M725.534 123.894L728.592 120.736H750.249L753.308 123.894V142.995L750.249 146.003H728.592L725.534 142.995V123.894Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M725.534 128.98L753.308 128.88",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M725.534 137.603L753.308 137.503",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M697.158 123.894L700.216 120.736H721.874L724.932 123.894V142.995L721.874 146.003H700.216L697.158 142.995V123.894Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M697.158 128.98L724.932 128.88",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M697.158 137.603L724.932 137.503",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M668.783 212.476L671.841 209.318H693.498L696.556 212.476V231.577L693.498 234.585H671.841L668.783 231.577V212.476Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M668.783 217.562L696.556 217.462",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M668.783 226.185L696.556 226.085",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M753.909 212.476L756.968 209.318H778.625L781.683 212.476V231.577L778.625 234.585H756.968L753.909 231.577V212.476Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M753.909 217.562L781.683 217.462",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M753.909 226.185L781.683 226.085",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M725.534 212.476L728.592 209.318H750.249L753.308 212.476V231.577L750.249 234.585H728.592L725.534 231.577V212.476Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M725.534 217.562L753.308 217.462",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M725.534 226.185L753.308 226.085",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M697.158 212.476L700.216 209.318H721.874L724.932 212.476V231.577L721.874 234.585H700.216L697.158 231.577V212.476Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M697.158 217.562L724.932 217.462",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M697.158 226.185L724.932 226.085",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M768.008 270.145H682.583V359.179H768.008V270.145Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M768.609 264.229H681.981V270.245H768.609V264.229Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M682.583 295.812H768.008",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M759.699 317.03H689.989V358.74H759.699V317.03Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M759.699 314.223H689.989V317.03H759.699V314.223Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M759.135 312.732H690.554V314.311H759.135V312.732Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M738.944 303.996H711.646V306.803H738.944V303.996Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M738.944 301.189H711.646V303.996H738.944V301.189Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M700.782 308.664H698.186V312.689H700.782V308.664Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M700.201 308.664H697.786V310.154H700.201V308.664Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M702.158 308.664H700.201V310.154H702.158V308.664Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M697.786 308.664H696.81V310.154H697.786V308.664Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M702.158 308.664H696.81V310.154H702.158V308.664Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M704.874 311.704H694.045V312.606H704.874V311.704Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M751.892 308.446H749.296V312.471H751.892V308.446Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M751.311 308.446H748.896V309.936H751.311V308.446Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M753.268 308.446H751.311V309.936H753.268V308.446Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M748.896 308.446H747.92V309.936H748.896V308.446Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M753.268 308.446H747.92V309.936H753.268V308.446Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M756.009 311.704H745.18V312.606H756.009V311.704Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M682.433 275.938H680.794V280.842H682.433V275.938Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M769.524 275.938H767.885V280.842H769.524V275.938Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M769.524 349.532H767.885V354.436H769.524V349.532Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M682.433 349.532H680.794V354.436H682.433V349.532Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M731.099 393.262H719.83V438.481H731.099V393.262Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M725.465 403.829C726.102 403.829 726.618 403.313 726.618 402.676C726.618 402.039 726.102 401.523 725.465 401.523C724.828 401.523 724.312 402.039 724.312 402.676C724.312 403.313 724.828 403.829 725.465 403.829Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M727.913 359.448H723.159V363.073H727.913V359.448Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M727.913 266.635H723.159V270.259H727.913V266.635Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M465.412 393.262V381.43H508.325V393.262H519.154V437.978H454.271V393.262H465.412Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M500.304 349.532H473.578V381.43H500.304V349.532Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M503.04 349.532H500.376V381.43H503.04V349.532Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M473.578 349.532H470.914V381.43H473.578V349.532Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M486.975 360.387C488.448 360.387 489.645 361.58 489.645 363.057C489.645 364.529 488.448 365.727 486.975 365.727C485.499 365.727 484.305 364.53 484.305 363.057C484.305 361.58 485.499 360.387 486.975 360.387Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M487.618 351.149H475.314V357.766H487.618V351.149Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M476.674 351.64C476.981 351.64 477.229 351.888 477.229 352.195C477.229 352.502 476.98 352.75 476.674 352.75C476.367 352.75 476.119 352.501 476.119 352.195C476.119 351.888 476.368 351.64 476.674 351.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M486.343 356.008C486.65 356.008 486.898 356.257 486.898 356.563C486.898 356.87 486.649 357.118 486.343 357.118C486.036 357.118 485.788 356.869 485.788 356.563C485.788 356.256 486.037 356.008 486.343 356.008Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M501.708 345.167H496.895V349.532H501.708V345.167Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M497.998 337.011H475.952V349.531H497.998V337.011Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M508.326 356.915H503.513V368.947H508.326V356.915Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M470.326 356.915H465.513V368.947H470.326V356.915Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M449.27 357.164V368.946H456.79V365.387H465.332V360.575H456.79V357.164H449.27Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M524.378 357.035V368.817H516.858V365.258H508.316V360.446H516.858V357.035H524.378Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M449.27 358.755H437V367.097H449.27V358.755Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M475.952 340.121H497.998",
    stroke: "#F7F9F9",
    strokeWidth: 0.5
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M441.82 347.883H439.556V351.182H441.82V347.883Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M443.653 347.883H441.819V351.182H443.653V347.883Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M439.556 347.883H438.641V351.182H439.556V347.883Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M443.653 347.883H438.641V351.182H443.653V347.883Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M440.914 351.277H438.25V358.755H440.914V351.277Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M444.122 351.277H441.458V358.755H444.122V351.277Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M442.48 351.277H439.816V358.755H442.48V351.277Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M441.82 368.186H439.556V369.835H441.82V368.186Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M443.653 368.186H441.819V369.835H443.653V368.186Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M439.556 368.186H438.641V369.835H439.556V368.186Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M443.653 368.186H438.641V369.835H443.653V368.186Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M442.739 369.836H440.475V371.486H442.739V369.836Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M440.475 369.836H438.641V371.486H440.475V369.836Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M443.654 369.836H442.739V371.486H443.654V369.836Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M443.653 369.836H438.641V371.486H443.653V369.836Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M440.876 371.486H438.212V378.965H440.876V371.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M444.083 371.486H441.419V378.965H444.083V371.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M442.441 371.486H439.777V378.965H442.441V371.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M441.583 367.139H440.451V368.145H441.583V367.139Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M442.5 367.139H441.583V368.145H442.5V367.139Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M440.451 367.139H439.994V368.145H440.451V367.139Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M442.5 367.139H439.994V368.145H442.5V367.139Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M515.832 359.591H514.699V360.597H515.832V359.591Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M516.749 359.591H515.832V360.597H516.749V359.591Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M514.699 359.591H514.242V360.597H514.699V359.591Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M516.748 359.591H514.242V360.597H516.748V359.591Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M515.832 365.486H514.699V366.492H515.832V365.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M516.749 365.486H515.832V366.492H516.749V365.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M514.699 365.486H514.242V366.492H514.699V365.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M516.748 365.486H514.242V366.492H516.748V365.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M506.025 355.861H504.893V356.867H506.025V355.861Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M506.942 355.861H506.025V356.867H506.942V355.861Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M504.893 355.861H504.436V356.867H504.893V355.861Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M506.942 355.861H504.436V356.867H506.942V355.861Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M468.715 355.861H467.583V356.867H468.715V355.861Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M467.583 355.861H466.666V356.867H467.583V355.861Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M469.172 355.861H468.715V356.867H469.172V355.861Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M469.172 355.861H466.666V356.867H469.172V355.861Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M536.619 358.885H524.348V367.226H536.619V358.885Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M533.514 347.883H531.251V351.182H533.514V347.883Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M535.349 347.883H533.515V351.182H535.349V347.883Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M531.251 347.883H530.336V351.182H531.251V347.883Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M535.348 347.883H530.336V351.182H535.348V347.883Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M532.609 351.277H529.945V358.755H532.609V351.277Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M535.816 351.277H533.152V358.755H535.816V351.277Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M534.175 351.277H531.511V358.755H534.175V351.277Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M533.514 368.186H531.251V369.835H533.514V368.186Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M535.348 368.186H533.514V369.835H535.348V368.186Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M531.251 368.186H530.336V369.835H531.251V368.186Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M535.348 368.186H530.336V369.835H535.348V368.186Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M534.435 369.836H532.17V371.486H534.435V369.836Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M532.17 369.836H530.336V371.486H532.17V369.836Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M535.348 369.836H534.434V371.486H535.348V369.836Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M535.348 369.836H530.336V371.486H535.348V369.836Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M532.571 371.486H529.907V378.965H532.571V371.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M535.779 371.486H533.115V378.965H535.779V371.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M534.136 371.486H531.472V378.965H534.136V371.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M533.452 367.111H532.319V368.117H533.452V367.111Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M534.368 367.111H533.451V368.117H534.368V367.111Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M532.319 367.111H531.862V368.117H532.319V367.111Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M534.368 367.111H531.862V368.117H534.368V367.111Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M529.045 356.15H527.912V358.613H529.045V356.15Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M527.911 356.15H526.995V358.613H527.911V356.15Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M529.502 356.15H529.045V358.613H529.502V356.15Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M529.501 356.15H526.995V358.613H529.501V356.15Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M458.89 365.486H457.758V366.492H458.89V365.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M459.806 365.486H458.89V366.492H459.806V365.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M457.759 365.486H457.301V366.492H457.759V365.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M459.807 365.486H457.301V366.492H459.807V365.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M459.35 359.591H458.218V360.597H459.35V359.591Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M458.218 359.591H457.301V360.597H458.218V359.591Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M459.807 359.591H459.35V360.597H459.807V359.591Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M459.807 359.591H457.301V360.597H459.807V359.591Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M446.247 356.15H445.115V358.613H446.247V356.15Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M447.164 356.15H446.247V358.613H447.164V356.15Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M445.115 356.15H444.658V358.613H445.115V356.15Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M447.164 356.15H444.658V358.613H447.164V356.15Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M468.715 368.83H467.583V369.836H468.715V368.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M467.583 368.83H466.666V369.836H467.583V368.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M469.172 368.83H468.715V369.836H469.172V368.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M469.172 368.83H466.666V369.836H469.172V368.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M506.486 368.83H505.353V369.836H506.486V368.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M505.352 368.83H504.436V369.836H505.352V368.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M506.942 368.83H506.485V369.836H506.942V368.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M506.942 368.83H504.436V369.836H506.942V368.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M465.333 383.36H464.626V393.144H465.333V383.36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M465.233 392.6H456.639V393.307H465.233V392.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M509.077 383H508.37V392.784H509.077V383Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M517.063 392.24H508.469V392.947H517.063V392.24Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M532.523 364.306C533.16 364.306 533.676 363.79 533.676 363.153C533.676 362.516 533.16 362 532.523 362C531.886 362 531.37 362.516 531.37 363.153C531.37 363.79 531.886 364.306 532.523 364.306Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M441.523 364.306C442.16 364.306 442.676 363.79 442.676 363.153C442.676 362.516 442.16 362 441.523 362C440.886 362 440.37 362.516 440.37 363.153C440.37 363.79 440.886 364.306 441.523 364.306Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25279 453.602H846.092V575.779L773.531 527.404L668.099 572.677L561.425 527.403L469.018 613.61L369.166 642.14L325.133 605.548L290.402 552.831L257.532 584.462L184.349 523.062L133.493 530.505L76.4358 481.509L2.63379 462.904L3.25279 453.602Z",
    fill: "#384252",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M3.253 453.602V454.203H845.491V574.655L773.593 526.722L668.098 572.023L561.301 526.697L468.713 613.071L369.306 641.474L325.586 605.142L290.506 551.896L257.504 583.653L184.529 522.428L133.677 529.869L76.72 480.961L3.267 462.443L3.853 453.642L3.253 453.602V454.203V453.602L2.653 453.562L2 463.364L76.152 482.058L133.309 531.14L184.169 523.697L257.559 585.27L290.298 553.767L324.679 605.953L369.026 642.805L469.322 614.148L561.55 528.109L668.1 573.331L773.468 528.085L846.694 576.903V453H2.69L2.653 453.562L3.253 453.602Z",
    fill: "#384252"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M3.253 453.602V454.203H845.491V574.655L773.593 526.722L668.098 572.023L561.301 526.697L468.713 613.071L369.306 641.474L325.586 605.142L290.506 551.896L257.504 583.653L184.529 522.428L133.677 529.869L76.72 480.961L3.267 462.443L3.853 453.642L3.253 453.602ZM3.253 453.602V454.203V453.602ZM3.253 453.602L2.653 453.562L2 463.364L76.152 482.058L133.309 531.14L184.169 523.697L257.559 585.27L290.298 553.767L324.679 605.953L369.026 642.805L469.322 614.148L561.55 528.109L668.1 573.331L773.468 528.085L846.694 576.903V453H2.69L2.653 453.562L3.253 453.602Z",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M815 438H320V454H815V438Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChemicalInjectionPumpDigiUltra);
export default __webpack_public_path__ + "static/media/chemical-injection-pump-digi-ultra.cae0e04ce21da612499dbaf1b701f242.svg";
export { ForwardRef as ReactComponent };